import { render } from "./tep-itp-address-buttons.vue?vue&type=template&id=891ce90c&scoped=true"
import script from "./tep-itp-address-buttons.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-itp-address-buttons.vue?vue&type=script&setup=true&lang=js"

import "./tep-itp-address-buttons.vue?vue&type=style&index=0&id=891ce90c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891ce90c"],['__file',"src/views/tep/tep-grid/components/tep-itp-address-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "891ce90c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('891ce90c', __exports__)) {
    api.reload('891ce90c', __exports__)
  }
  
  module.hot.accept("./tep-itp-address-buttons.vue?vue&type=template&id=891ce90c&scoped=true", () => {
    api.rerender('891ce90c', render)
  })

}


export default __exports__